import script from "./MimioRichEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./MimioRichEditor.vue?vue&type=script&setup=true&lang=js"

import "./MimioRichEditor.vue?vue&type=style&index=0&id=1aa9b42b&lang=css"
import "./MimioRichEditor.vue?vue&type=style&index=1&id=1aa9b42b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aa9b42b"]])

export default __exports__